import { Reducer } from "redux";
import { AppThunkAction } from "./";
import * as Initial from "./initialStatus";
import axios from "axios";
import { Request } from "../helpers/func";
import { isNullOrUndefined } from "../helpers/func";
import {url} from "./initialStatus";

export interface SchoolEnvState {
  id: number|null;
  key: string;
  fullname: string;
  logo: string;
  location: string;
  color: string;
  secondcol: string;
  mobile: string;
  informail: string;
  loading: boolean;
  error: string | null;
  initialized: boolean;
}

export const initialSchoolEnvState: SchoolEnvState = {
  id: null,
  key: "",
  fullname: "",
  logo: "",
  location: "",
  color: "",
  secondcol: "",
  mobile: "",
  informail: "",
  loading: false,
  error: null,
  initialized: false,
}


export const SchoolEnvReducer: Reducer<SchoolEnvState> = (
  state: SchoolEnvState | undefined,
  action
): SchoolEnvState => {
  if (state === undefined || state === null) {
    state = initialSchoolEnvState;
  }

  switch (action.type) {
    case "FETCH_SCHOOL_ENV_START":
      return { ...state, loading: true, error: null };

    case "FETCH_SCHOOL_ENV_SUCCESS":
      return { ...state, ...action.payload, loading: false, initialized: true };

    case "FETCH_SCHOOL_ENV_ERROR":
      return { ...state, loading: false, error: action.payload, initialized: true };

    default:
      return state;
  }
};




export const fetchSchoolEnv = () => {
  return async (dispatch: any) => {
    dispatch({ type: "FETCH_SCHOOL_ENV_START" });

    try {
      const domain = localStorage.getItem("emaildomain") || "";
      
      const fullurl = `${url}general/getschoolenv.php`;

      const response = await axios.get(`${fullurl}?domain=${domain}`);

      dispatch({
        type: "FETCH_SCHOOL_ENV_SUCCESS",
        payload: { ...response.data.data },
      });
    } catch (err) {
      dispatch({
        type: "FETCH_SCHOOL_ENV_ERROR",
        payload: err,
      });
    }
  };
};
